import { StoreButton } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const StoreBtn = styled(StoreButton)<{ isMobile: boolean }>`
    width: 151.88px !important;
    height: 45px !important;
    display: block;
`;
